<template>

  <modalo
    :title="modalTitle"
    :creating="creating"
    type="medium"
    @hideModal="hideModal()"
    :modaloWatch="() => requisition">

    <RequisitionPreset
      v-if="startPreset"
      @input="preset" />

    <form
      v-if="!startPreset"
      id="requisition-form"
      v-on:submit.prevent="saveRequisition(requisition)">

      <div class="card mb-4">
        <div class="card-header">
          {{ $t('General information') }}
        </div>
        <div class="card-body">

          <div class="row">
            <div class="col-sm-10">
              <div class="form-group">
                <label class="control-label">* {{ $t('Title') }}</label>
                <input v-autofocus class="form-control" type="text" v-model="requisition.title">
                <ValidateMessage :error="validateErrors.title" />
              </div>
            </div>
            <div class="col-sm-2">
              <div class="form-group">
                <label class="control-label">{{ requiredMark }}{{ $t('Number of openings') }}</label>
                <input class="form-control" type="text" v-model="requisition.openings">
                <ValidateMessage :error="validateErrors.openings" />
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-sm">
              <div class="form-group">
                <label class="control-label">{{ requiredMark }}{{ $t('Company') }}</label>
                <select-company v-model="requisition.company_id" @inputObject="setAddress"></select-company>
                <ValidateMessage :error="validateErrors.company_id" />
              </div>
            </div>
            <div class="col-sm">
              <div class="form-group">
                <label class="control-label">{{ requiredMark }}{{ $t('Department') }}</label>
                <select-departament v-model="requisition.departament_id"></select-departament>
                <ValidateMessage :error="validateErrors.departament_id" />
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-sm">
              <div class="form-group">
                <label class="control-label">{{ requiredMark }}{{ $t('Hiring manager') }}</label>
                
                <div class="input-group">
                  <input type="text" class="form-control" :placeholder="$t('Name')" v-model="requisition.hiring_manager_name">
                  <input type="text" class="form-control" :placeholder="$t('Email')" v-model="requisition.hiring_manager_email">
                </div>
                <ValidateMessage :error="validateErrors.hiring_manager_name" />
                <ValidateMessage :error="validateErrors.hiring_manager_email" />

              </div>
            </div>
            <div class="col-sm">
              <div class="form-group">
                <label class="control-label">{{ requiredMark }}{{ $t('Owner') }}</label>
                <select-user v-model="requisition.owner_user_id"></select-user>
                <ValidateMessage :error="validateErrors.owner_user_id" />
              </div>
            </div>
          </div>

        </div>
      </div>

      <div class="card mb-4">
        <div class="card-header">
          {{ $t('Location') }}
        </div>
        <div class="card-body">

          <div class="row">
            <div class="col-sm">
              <div class="form-group">
                <label class="control-label">{{ requiredMark }}{{ $t('Country') }}</label>
                <select-country v-model="requisition.country"></select-country>
                <ValidateMessage :error="validateErrors.country" />
              </div>
            </div>
            <div class="col-sm">
              <div class="form-group">
                <label class="control-label">{{ requiredMark }}{{ $t('State') }}</label>
                <input class="form-control" type="text" v-model="requisition.region">
                <ValidateMessage :error="validateErrors.region" />
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-sm">
              <div class="form-group">
                <label class="control-label">{{ requiredMark }}{{ $t('City') }}</label>
                <input class="form-control" type="text" v-model="requisition.city">
                <ValidateMessage :error="validateErrors.city" />
              </div>
            </div>
            <div class="col-sm">
              <div class="form-group">
                <label class="control-label">{{ $t('Neighborhood') }}</label>
                <input class="form-control" type="text" v-model="requisition.neighborhood">
                <ValidateMessage :error="validateErrors.neighborhood" />
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-sm">
              <div class="form-group">
                <label class="control-label">{{ $t('Address') }}</label>
                <input class="form-control" type="text" v-model="requisition.address">
                <ValidateMessage :error="validateErrors.address" />
              </div>
            </div>
            <div class="col-sm">
              <div class="form-group">
                <label class="control-label">{{ $t('Zip code') }}</label>
                <input class="form-control" type="text" v-model="requisition.zipcode">
                <ValidateMessage :error="validateErrors.zipcode" />
              </div>
            </div>
          </div>

          <div>
          <div class="form-check form-check-inline">
            <input
              class="form-check-input"
              type="radio"
              id="on-site"
              value="on-site"
              v-model="requisition.workplace_type">
            <label
              class="form-check-label"
              for="on-site">
              {{ $t('On-site') }}
            </label>
          </div>
          <div class="form-check form-check-inline">
            <input
              class="form-check-input"
              type="radio"
              id="remote"
              value="remote"
              v-model="requisition.workplace_type">
            <label
              class="form-check-label"
              for="remote">
              {{ $t('Remote') }}
            </label>
          </div>
          <div class="form-check form-check-inline">
            <input
              class="form-check-input"
              type="radio"
              id="hybrid"
              value="hybrid"
              v-model="requisition.workplace_type">
            <label
              class="form-check-label"
              for="hybrid">
              {{ $t('Hybrid') }}
            </label>
          </div>
        </div>
        <ValidateMessage :error="validateErrors.workplace_type" />

        </div>
      </div>

      <div class="card mb-4">
        <div class="card-header">
          {{ requiredMark }}{{ $t('Description') }}
        </div>
        <textarea-editable
          v-model="requisition.description"
          editor-model="html"
          :enable-link="true"
          :enable-img="true"></textarea-editable>
        <ValidateMessage :error="validateErrors.description" />
        <div class="card-header">
          {{ requiredMark }}{{ $t('Requirements') }}
        </div>
        <textarea-editable
          v-model="requisition.requirements"
          editor-model="html"
          :enable-link="true"
          :enable-img="true"></textarea-editable>
        <ValidateMessage :error="validateErrors.requirements" />
        <div class="card-header">
          {{ $t('Benefits') }}
        </div>
        <textarea-editable
          v-model="requisition.benefits"
          editor-model="html"
          :enable-link="true"
          :enable-img="true"></textarea-editable>
        <ValidateMessage :error="validateErrors.benefits" />
      </div>

      <div class="card mb-4">
        <div class="card-header">
          {{ $t('Remuneration') }}
        </div>
        <div class="card-body">

          <div class="row">
            <div class="col-sm">
              <div class="form-group">
                <label class="control-label">{{ requiredMark }}{{ $t('Currency') }}</label>
                <select-currency v-model="requisition.currency"></select-currency>
                <ValidateMessage :error="validateErrors.currency" />
              </div>
            </div>
            <div class="col-sm">
              <div class="form-group">
                <label class="control-label">{{ $t('From') }}</label>
                <input-money
                  v-model="requisition.remuneration"
                  :locale="$i18n.locale"
                  :placeholder="$n(0, {style: 'decimal', minimumFractionDigits: 2})">
                  </input-money>
                <ValidateMessage :error="validateErrors.remuneration" />
              </div>
            </div>
            <div class="col-sm">
              <div class="form-group">
                <label class="control-label">{{ $t('To') }}</label>
                <input-money
                  v-model="requisition.remuneration_max"
                  :locale="$i18n.locale"
                  :placeholder="$n(0, {style: 'decimal', minimumFractionDigits: 2})">
                  </input-money>
                <ValidateMessage :error="validateErrors.remuneration_max" />
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-sm">
              <div class="form-group">
                <label class="control-label">{{ $t('Per') }}</label>
                <select class="form-control" v-model="requisition.remuneration_period">
                  <option value="year">{{ $t('Year') }}</option>
                  <option value="month">{{ $t('Month') }}</option>
                  <option value="hour">{{ $t('Hour') }}</option>
                </select>
                <ValidateMessage :error="validateErrors.remuneration_period" />
              </div>
            </div>
            <div class="col-sm">
              <div class="form-group">
                <label class="control-label">{{ requiredMark }}{{ $t('Contract type') }}</label>
                <select-contract v-model="requisition.contract_id"></select-contract>
                <ValidateMessage :error="validateErrors.contract_id" />
              </div>
            </div>
          </div>

        </div>
      </div>

      <div class="card mb-4">
        <div class="card-header">
          {{ $t('Details') }}
        </div>
        <div class="card-body">
          
          <div class="row">
            <div class="col-sm">
              <div class="form-group">
                <label class="control-label">{{ requiredMark }}{{ $t('Professional category') }}</label>
                <select-position-category v-model="requisition.position_category"></select-position-category>
                <ValidateMessage :error="validateErrors.position_category" />
              </div>
            </div>
            <div class="col-sm">
              <div class="form-group">
                <label class="control-label">{{ requiredMark }}{{ $t('Experience level') }}</label>
                <select-experience-level v-model="requisition.experience_level"></select-experience-level>
                <ValidateMessage :error="validateErrors.experience_level" />
              </div>
            </div>
            <div class="col-sm">
              <div class="form-group">
                <label class="control-label">{{ requiredMark }}{{ $t('Last education') }}</label>
                <select-education-degree v-model="requisition.education_degree"></select-education-degree>
                <ValidateMessage :error="validateErrors.education_degree" />
              </div>
            </div>
          </div>

        </div>
      </div>

      <div class="card mb-4">
        <div class="card-header">
          {{ $t('Internal Comments') }}
        </div>
        <textarea class="form-control" rows="5" v-model="requisition.comments"></textarea>
        <ValidateMessage :error="validateErrors.comments" />
      </div>

      <custom-form 
        :initCustomFields="requisition.custom_fields"
        :modelType="'requisition'"
        :validateErrors="validateErrors"
        :hideRequired="template"
        @changed="$set(requisition, 'custom_fields', arguments[0])">
        </custom-form>

    </form>

    <template slot="footer">
      <div :class="{'box-loading': loading}">
        <button
          v-if="!startPreset"
          type="submot"
          form="requisition-form"
          class="btn btn-primary">{{ $t('Save') }}</button>
        <button
          type="button"
          class="btn btn-light"
          @click.stop="hideModal()">{{ $t('Cancel') }}</button>
      </div>
    </template>

  </modalo>

</template>

<script>
import CustomForm from '@/components/Parts/CustomForm'
import SelectUser from '@/components/Fields/SelectUser'
import SelectContract from '@/components/Fields/SelectContract'
import SelectCompany from '@/components/Fields/SelectCompany'
import SelectDepartament from '@/components/Fields/SelectDepartament'
import SelectCountry from '@/components/Fields/SelectCountry'
import SelectCurrency from '@/components/Fields/SelectCurrency'
import SelectPositionCategory from '@/components/Fields/SelectPositionCategory'
import SelectExperienceLevel from '@/components/Fields/SelectExperienceLevel'
import SelectEducationDegree from '@/components/Fields/SelectEducationDegree'
import InputMoney from '@/components/Fields/InputMoney'
import RequisitionPreset from './RequisitionPreset'

export default {
  name: 'RequisitionForm',
  components: {
    CustomForm,
    SelectUser,
    SelectContract,
    SelectCompany,
    SelectDepartament,
    SelectCountry,
    SelectCurrency,
    SelectPositionCategory,
    SelectExperienceLevel,
    SelectEducationDegree,
    InputMoney,
    RequisitionPreset
  },
  props: {
    'initRequisition': {
      type: Object
    },
    'template': {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      loading: false,
      requisition: this.defaultValues(this.initRequisition),
      validateErrors: {},
      creating: true,
      startPreset: true
    }
  },
  computed: {
    resources () {
      return this.$store.getters.getResources
    },
    requiredMark () {
      // Em templates apenas o título é obrigatório
      return this.template ? '' : '* '
    },
    modalTitle () {
      if (this.requisition && this.requisition.title) {
        return this.requisition.title
      } else if (this.template) {
        return this.$t('New template')
      } else {
        return this.$t('New requisition')
      }
    }
  },
  created () {
    this.definedStartPreset()
  },
  methods: {
    definedStartPreset () {
      if (this.initRequisition._id || this.template) {
        this.startPreset = false
        this.creating = false
      } else {
        this.$store
        .dispatch('getRequisitions', {
          template: true,
          limit: 1
        })
        .then(result => {
          this.startPreset = result.total >= 1
          this.creating = false
        })
      }
    },
    /*
    defaultValues
    */
    defaultValues (values) {
      const accountSettings = this.$store.getters.getAccount.settings || {}

      return values._id
      ? this.$clone(values)
      : Object.assign({
        'status': 'analyzing',
        'openings': 1,
        'remuneration_period': 'month',
        'title': null,
        'description': null,
        'requirements': null,
        'benefits': null,
        'comments': null,
        'currency': accountSettings.currency_default,
        'remuneration': null,
        'remuneration_max': null,
        'country': null,
        'region': null,
        'city': null,
        'neighborhood': null,
        'address': null,
        'zipcode': null,
        'workplace_type': null,
        'hiring_manager_name': null,
        'hiring_manager_email': null,
        'company_id': null,
        'departament_id': null,
        'contract_id': null,
        'owner_user_id': null,
        'category': null,
        'experience_level': null,
        'education_degree': null,
        'custom_fields': {}
      }, values)
    },
    /*
    preset
    */
    preset (values) {
      this.startPreset = false
      this.requisition = this.defaultValues(values)
    },
    /*
    hideModal
    */
    hideModal () {
      this.$emit('hideModal')
    },
    /*
    saveRequisition
    */
    saveRequisition (data) {
      const ndata = {
        ...data,
        template: this.template
      }
      if (ndata._id) this.updateRequisition(ndata)
      else this.createRequisition(ndata)
    },
    /*
    createRequisition
    */
    createRequisition (data) {
      this.loading = true

      this.$store
      .dispatch('createRequisition', data)
      .then((response) => {
        this.loading = false
        this.$store.dispatch('refreshSelectRequisitions')
        this.requisition = response
        this.$emit('saved', this.requisition)
      })
      .catch((err) => {
        this.loading = false
        if (err.response.data.name === 'ValidationError') {
          this.validateErrors = err.response.data.errors
        }
      })
    },
    /*
    updateRequisition
    */
    updateRequisition (data) {
      this.loading = true

      this.$store
      .dispatch('updateRequisition', data)
      .then((response) => {
        this.loading = false
        this.$store.dispatch('refreshSelectRequisitions')
        this.requisition = response
        this.$emit('saved', this.requisition)
      })
      .catch((err) => {
        this.loading = false
        if (err.response.data.name === 'ValidationError') {
          this.validateErrors = err.response.data.errors
        }
      })
    },
    /*
    deleteRequisition
    */
    deleteRequisition (id) {
      const deleteAction = () => {
        this.loading = true

        this.$store.dispatch('deleteRequisition', id)
        .then((result) => {
          this.loading = false
          this.$emit('deleted')
        })
      }

      this.$store
      .dispatch('setAlertModal', {
        action: deleteAction
      })
    },
    /*
    setAddress
    */
    setAddress (params) {
      this.requisition = Object.assign(this.requisition, {
        country: params ? params.country : null,
        region: params ? params.region : null,
        city: params ? params.city : null,
        neighborhood: params ? params.neighborhood : null,
        address: params ? params.address : null,
        zipcode: params ? params.zipcode : null
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/RequisitionForm/RequisitionForm.vue